import Vue from 'vue'
import Meta from 'vue-meta'
import VueDraggableResizable from 'vue-draggable-resizable'

import'@/assets/css/vtooltip.css'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'


Vue.use(Meta)
Vue.component('VueDraggableResizable', VueDraggableResizable)
